var React = require('react');

function LuxeSelected (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.5","y":"0.5","width":"18","height":"18","rx":"9","fill":"#FBF7EC","stroke":"#2D2927","key":0}),React.createElement("path",{"d":"M5 10.5279L7.96075 12.893L14 7","stroke":"#2D2927","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

LuxeSelected.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none"};

module.exports = LuxeSelected;

LuxeSelected.default = LuxeSelected;
